import { render, staticRenderFns } from "./settings-card.vue?vue&type=template&id=17efd65c&scoped=true"
import script from "./settings-card.vue?vue&type=script&lang=js"
export * from "./settings-card.vue?vue&type=script&lang=js"
import style0 from "./settings-card.vue?vue&type=style&index=0&id=17efd65c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17efd65c",
  null
  
)

export default component.exports